import AppLayout from "@/components/features/AppLayout/AppLayout";
import { applySubdomainBranding, getSubdomainBranding } from "@/utils/subdomainBranding";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";

// import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";
// import { TanStackDevtools } from "@tanstack/react-devtools";

// Required for Mantine components to work properly
import "@mantine/core/styles.css";
import "@mantine/tiptap/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
// Required for Mantine components to work properly

export const Route = createRootRoute({
  loader: async () => {
    // Apply per-subdomain branding (favicon + primary color) on every full
    // page load so refreshes on authenticated routes also reflect the tenant.
    const branding = await getSubdomainBranding();
    applySubdomainBranding(branding);
    return branding;
  },
  component: () => (
    <NuqsAdapter>
      <AppLayout>
        <Outlet />
        {/* <TanStackDevtools
        config={{
          position: "bottom-right",
        }}
        plugins={[
          {
            name: "Tanstack Router",
            render: <TanStackRouterDevtoolsPanel />,
          },
        ]}
      /> */}
      </AppLayout>
    </NuqsAdapter>
  ),
});
